import React from 'react';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import ContentRow from '../components/ContentRow';
import Logo from '../components/Logo';
import { useCatalog } from '../context/CatalogContext';

export default function Originals() {
  const { movies, shows, podcasts } = useCatalog();
  const om = movies.filter((m) => m.isOriginal);
  const os = shows.filter((s) => s.isOriginal && !s.genres.includes('Documentary'));
  const od = [...shows, ...movies].filter((s) => s.isOriginal && s.genres.includes('Documentary'));
  const op = podcasts.filter((p) => p.isOriginal);
  return (
    <Layout>
      <div className="px-[22px] pt-[26px] pb-[14px] flex items-center gap-3" data-testid="originals-header">
        <Logo height={30} />
        <h1 className="page-title">ORIGINALS</h1>
        <span className="ml-2 text-[11px] font-semibold tracking-[0.16em] uppercase text-[#8B2CFF] border border-[#8B2CFF]/40 bg-[#8B2CFF]/10 px-2.5 py-1 rounded-full">Only on Clax</span>
      </div>
      <div className="px-[22px]"><div className="rounded-xl overflow-hidden ring-1 ring-[#8B2CFF]/30"><Hero slides={[{ contentId: 'the-kingdoms' }, { contentId: 'city-of-lights' }, { contentId: 'neon-horizon' }, { contentId: 'the-heiress' }]} /></div></div>
      <ContentRow title="Original Movies" items={om} testId="originals-movies" />
      <ContentRow title="Original Series" items={os} testId="originals-series" />
      <ContentRow title="Original Documentaries" items={od.length ? od : shows.filter((s) => s.genres.includes('Documentary'))} testId="originals-docs" />
      <ContentRow title="Original Podcasts" items={op} testId="originals-podcasts" />
      <div className="h-10" />
    </Layout>
  );
}
